import { __ } from "@wordpress/i18n";
import * as Icon from "../components/Icons";

export const BLOCKS = {
	section: {
		label: __("Section", "magazine-blocks"),
		icon: Icon.Section,
		blockName: "magazine-blocks/section",
	},
	heading: {
		label: __("Heading", "magazine-blocks"),
		icon: Icon.Heading,
		blockName: "magazine-blocks/heading",
	},
	archive: {
		label: __("Archive", "magazine-blocks"),
		icon: Icon.Archive,
		blockName: "magazine-blocks/archive",
	},
	advertisement: {
		label: __("Advertisement", "magazine-blocks"),
		icon: Icon.Advertisement,
		blockName: "magazine-blocks/advertisement",
	},
	"banner-posts": {
		label: __("Banner Posts", "magazine-blocks"),
		icon: Icon.BannerPosts,
		blockName: "magazine-blocks/banner-posts",
	},
	breadcrumbs: {
		label: __("Breadcrumbs", "magazine-blocks"),
		icon: Icon.Breadcrumbs,
		blockName: "magazine-blocks/breadcrumbs",
	},
	category: {
		label: __("Category", "magazine-blocks"),
		icon: Icon.Category,
		blockName: "magazine-blocks/category",
	},
	"category-list": {
		label: __("Category List", "magazine-blocks"),
		icon: Icon.CategoryList,
		blockName: "magazine-blocks/category-list",
	},
	"date-weather": {
		label: __("Date & Weather", "magazine-blocks"),
		icon: Icon.DateWeather,
		blockName: "magazine-blocks/date-weather",
	},
	"featured-categories": {
		label: __("Featured Categories", "magazine-blocks"),
		icon: Icon.FeaturedCategories,
		blockName: "magazine-blocks/featured-categories",
	},
	"post-image": {
		label: __("Post Image", "magazine-blocks"),
		icon: Icon.FeaturedImage,
		blockName: "magazine-blocks/post-image",
	},
	"featured-posts": {
		label: __("Featured Posts", "magazine-blocks"),
		icon: Icon.FeaturedPosts,
		blockName: "magazine-blocks/featured-posts",
	},
	"grid-module": {
		label: __("Grid Module", "magazine-blocks"),
		icon: Icon.GridModule,
		blockName: "magazine-blocks/grid-module",
	},
	"news-ticker": {
		label: __("News Ticker", "magazine-blocks"),
		icon: Icon.NewsTicker,
		blockName: "magazine-blocks/news-ticker",
	},
	"post-content": {
		label: __("Post Content", "magazine-blocks"),
		icon: Icon.Heading,
		blockName: "magazine-blocks/post-content",
	},
	"post-list": {
		label: __("Post List", "magazine-blocks"),
		icon: Icon.PostList,
		blockName: "magazine-blocks/post-list",
	},
	"post-meta": {
		label: __("Post Meta", "magazine-blocks"),
		icon: Icon.Heading,
		blockName: "magazine-blocks/post-meta",
	},
	"post-title": {
		label: __("Post Title", "magazine-blocks"),
		icon: Icon.PostTitle,
		blockName: "magazine-blocks/post-title",
	},
	"post-video": {
		label: __("Post Video", "magazine-blocks"),
		icon: Icon.PostVideo,
		blockName: "magazine-blocks/post-video",
	},
	slider: {
		label: __("Slider", "magazine-blocks"),
		icon: Icon.Slider,
		blockName: "magazine-blocks/slider",
	},
	"social-icons": {
		label: __("Social Icons", "magazine-blocks"),
		icon: Icon.SocialIcons,
		blockName: "magazine-blocks/social-icons",
	},
	"tab-post": {
		label: __("Tab Post", "magazine-blocks"),
		icon: Icon.TabPost,
		blockName: "magazine-blocks/tab-post",
	},
};
